export enum StorageKeys {
  ACCESS_TOKEN = 'access-token'
}
